import { Component, computed, model } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from '../../shared/services/user.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MultiLangService } from '../../shared/services/multi-lang.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogsComponent } from '../../shared/components/dialogs/dialogs.component';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    TranslateModule,
    MatIconModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  isOpenSearch = model<boolean>();
  user = computed(() => this.userService.user());
  languageCode = '';
  combinedHeaderText = '';
  flow = false;
  finishLesson = false;

  constructor(
    private translate: TranslateService,
    public multiLangService: MultiLangService,
    private userService: UserService,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.languageCode = this.multiLangService.getStoredLanguage();
    this.translate.onLangChange.subscribe(x => {
      this.languageCode = x.lang;
    });
  }

  get fullName(): string {
    return this.user()?.fullName || '';
  }
  get initials(): string {
    return this.user()?.initials || '';
  }

  changeLanguage(language: string) {
    this.multiLangService.updateLanguage(language);
  }
  private getFlow(): void {
    this.flow = JSON.parse(sessionStorage.getItem('lessonFlow') || '{}');
    this.finishLesson = JSON.parse(sessionStorage.getItem('finishLesson') || '{}');
  }
  backToHome(): void {
    if (this.isOpenSearch()) {
      return;
    }
    this.getFlow();
    if (this.flow && this.finishLesson) {
      void this.router.navigate(['/']);
    } else {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      const dialogRef = this.dialog.open(DialogsComponent, {
        data: {
          dialogType: 'confirm_dialog',
          title: 'LESSONS.LESSONSDIALOGFLOW.TITLE',
          message: 'LESSONS.LESSONSDIALOGFLOW.MESSAGE',
          whiteButton: 'LESSONS.LESSONSDIALOGFLOW.LEAVEBUTTON',
          blueButton: 'LESSONS.LESSONSDIALOGFLOW.CONTINUEBUTTON',
          whiteButtonFsElement: 'Header-Dialog-Button-Leave',
          blueButtonFsElement: 'Header-Dialog-Button-Continue',
        },
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          void this.router.navigate(['/']);
        }
      });
    }
  }
}
